/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

export const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';
export const SET_IMPROVE_STATE = 'SET_IMPROVE_STATE';
export const SET_IMPROVE_PRSRV = 'SET_IMPROVE_PRSRV';
export const SET_IMPROVE_SOURCE = 'SET_IMPROVE_SOURCE';

export const FETCH_SKILL_HAS_DATA_START = 'FETCH_SKILL_HAS_DATA_START';
export const FETCH_SKILL_HAS_DATA_SUCCESS = 'FETCH_SKILL_HAS_DATA_SUCCESS';
export const FETCH_SKILL_HAS_DATA_ERROR = 'FETCH_SKILL_HAS_DATA_ERROR';

export const FETCH_AUTOLEARN_METRICS_START = 'FETCH_AUTOLEARN_METRICS_START';
export const FETCH_AUTOLEARN_METRICS_SUCCESS =
  'FETCH_AUTOLEARN_METRICS_SUCCESS';
export const FETCH_AUTOLEARN_METRICS_ERROR = 'FETCH_AUTOLEARN_METRICS_ERROR';

export const FETCH_AUTOLEARN_SAMPLES_START = 'FETCH_AUTOLEARN_SAMPLES_START';
export const FETCH_AUTOLEARN_SAMPLES_SUCCESS =
  'FETCH_AUTOLEARN_SAMPLES_SUCCESS';
export const FETCH_AUTOLEARN_SAMPLES_ERROR = 'FETCH_AUTOLEARN_SAMPLES_ERROR';

export const FETCH_USER_AND_SESSION_START = 'FETCH_USER_AND_SESSION_START';
export const FETCH_USER_AND_SESSION_SUCCESS = 'FETCH_USER_AND_SESSION_SUCCESS';
export const FETCH_USER_AND_SESSION_ERROR = 'FETCH_USER_AND_SESSION_ERROR';

export const FETCH_WEAK_UNDERSTANDING_START = 'FETCH_WEAK_UNDERSTANDING_START';
export const FETCH_WEAK_UNDERSTANDING_SUCCESS =
  'FETCH_WEAK_UNDERSTANDING_SUCCESS';
export const FETCH_WEAK_UNDERSTANDING_ERROR = 'FETCH_WEAK_UNDERSTANDING_ERROR';

export const FETCH_TOP_INTENTS_START = 'FETCH_TOP_INTENTS_START';
export const FETCH_TOP_INTENTS_SUCCESS = 'FETCH_TOP_INTENTS_SUCCESS';
export const FETCH_TOP_INTENTS_ERROR = 'FETCH_TOP_INTENTS_ERROR';

export const FETCH_TOP_ENTITIES_START = 'FETCH_TOP_ENTITIES_START';
export const FETCH_TOP_ENTITIES_SUCCESS = 'FETCH_TOP_ENTITIES_SUCCESS';
export const FETCH_TOP_ENTITIES_ERROR = 'FETCH_TOP_ENTITIES_ERROR';

export const FETCH_SKILL_REFERENCE_START = 'FETCH_SKILL_REFERENCE_START';
export const FETCH_SKILL_REFERENCE_SUCCESS = 'FETCH_SKILL_REFERENCE_SUCCESS';
export const FETCH_SKILL_REFERENCE_ERROR = 'FETCH_SKILL_REFERENCE_ERROR';

export const FETCH_DEPLOYMENT_LIST_START = 'FETCH_DEPLOYMENT_LIST_START';
export const FETCH_DEPLOYMENT_LIST_SUCCESS = 'FETCH_DEPLOYMENT_LIST_SUCCESS';
export const FETCH_DEPLOYMENT_LIST_ERROR = 'FETCH_DEPLOYMENT_LIST_ERROR';

export const FETCH_CONVERSATION_LOGS_START = 'FETCH_CONVERSATION_LOGS_START';
export const FETCH_CONVERSATION_LOGS_SUCCESS =
  'FETCH_CONVERSATION_LOGS_SUCCESS';
export const FETCH_CONVERSATION_LOGS_FAILURE =
  'FETCH_CONVERSATION_LOGS_FAILURE';

export const EDIT_CONVERSATION_LOGS_START = 'EDIT_CONVERSATION_LOGS_START';
export const EDIT_CONVERSATION_LOGS_SUCCESS = 'EDIT_CONVERSATION_LOGS_SUCCESS';
export const EDIT_CONVERSATION_LOGS_FAILURE = 'EDIT_CONVERSATION_LOGS_FAILURE';

export const FETCH_SINGLE_CONVERSATION_START =
  'FETCH_SINGLE_CONVERSATION_START';
export const FETCH_SINGLE_CONVERSATION_SUCCESS =
  'FETCH_SINGLE_CONVERSATION_SUCCESS';
export const FETCH_SINGLE_CONVERSATION_FAILURE =
  'FETCH_SINGLE_CONVERSATION_FAILURE';

export const CLEAR_DATA = 'CLEAR_DATA';
export const CLEAR_IMPROVE_STATE_PARAMS = 'CLEAR_IMPROVE_STATE_PARAMS';
export const TOGGLE_CONVERSATIONS = 'TOGGLE_CONVERSATIONS';

export const FETCH_CONTAINMENT_START = 'FETCH_CONTAINMENT_START';
export const FETCH_CONTAINMENT_SUCCESS = 'FETCH_CONTAINMENT_SUCCESS';
export const FETCH_CONTAINMENT_ERROR = 'FETCH_CONTAINMENT_ERROR';

export const FETCH_COVERAGE_START = 'FETCH_COVERAGE_START';
export const FETCH_COVERAGE_SUCCESS = 'FETCH_COVERAGE_SUCCESS';
export const FETCH_COVERAGE_ERROR = 'FETCH_COVERAGE_ERROR';
